import { render, staticRenderFns } from "./NovaPoshtaCreationPage.vue?vue&type=template&id=5b773b66"
import script from "./NovaPoshtaCreationPage.vue?vue&type=script&lang=js"
export * from "./NovaPoshtaCreationPage.vue?vue&type=script&lang=js"
import style0 from "./NovaPoshtaCreationPage.vue?vue&type=style&index=0&id=5b773b66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports